/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

const downArrow = "https://i.wlycdn.com/wealthy-home-page/partners-dropdown-arrow.svg";

const propTypes = {
  dropdownRef: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  setShowDropdown: PropTypes.func.isRequired,
  showDropdown: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired
};

const Dropdown = ({
  showDropdown,
  setShowDropdown,
  options,
  title,
  dropdownRef
}) => {
  return (
    <DropdownContainer ref={dropdownRef} onClick={() => setShowDropdown(!showDropdown)}>
      <TitleContainer>{title}</TitleContainer>
      <DropdownImage showDropdown={showDropdown}>
        <img
          alt="dropdown-icon"
          loading="lazy"
          src={downArrow}
        />
      </DropdownImage>
      {
        showDropdown && (
          <ul className="dropdown-menu">
            {options}
          </ul>
        )
      }
    </DropdownContainer>
  );
};

const DropdownImage = styled.div`
  width: 2.4rem;
  cursor: pointer;

    img {
  transform: ${({showDropdown}) => (showDropdown ? "rotate(180deg)" : "rotate(0)")};
  transition: transform 0.2s ease;
  vertical-align: middle;
  }

  @media (max-width: 768px) {
    width: 1.8rem;
    >img {
      width: 100%;
      vertical-align: middle;
    }
  }
`;

const TitleContainer = styled.div`
  font-family: MavenPro;
  font-size: 1.8rem;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.63;
  letter-spacing: normal;
  text-align: left;
  color: #6c6c6c;
`;

const DropdownContainer = styled.div`
  position: relative;
  display: flex;
  padding: 1rem 2.4rem;
  width: 80%;
  margin: 0 auto 3rem;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-radius: 1.2rem;
  height: 5rem;
  box-shadow: 4px 4px 20px rgb(0 0 0 / 15%);
  color: #6C6C6C;
  font-weight: 500;
  transition: all 0.2s ease-in-out;

  .dropdown-menu {
    display: block;
    top: 6.1rem;
    z-index: 1000;
    left: 0;
    width: 100%;
    border-radius: 1.2rem;
    max-height: 220px;
    width: 100%;
    background: #fff;
    overflow-y: scroll;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;
    position: absolute;
  }
  .dropdown-menu .dropdown-menu__item {
    font-size: 1.6rem;
    color: #6c6c6c;
    text-align: center;
    border-radius: 0;
    padding: 0.5rem 0 1rem;
  }

  :hover {
    cursor: pointer;
    box-shadow: 4px 4px 20px rgb(0 0 0 / 25%);
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 4.5rem;

    .dropdown-menu::after {
      display: none !important;
    }
  }

  @media (max-height: 660px) {
    height: 4.5rem;
  }

  @media (max-height: 600px) {
    height: 4.5rem;
  }
`;

Dropdown.propTypes = propTypes;

export default Dropdown;
